import CommentIcon from '@material-ui/icons/ChatRounded';
import CommentList from './CommentList';
import CommentCreate from './CommentCreate';

const commentModule = {
    list: CommentList,
    icon: CommentIcon,
    create: CommentCreate,
}; export default commentModule;